type Props = {
  className?: string;
  children: React.ReactNode[];
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
  size?: 'sm' | 'md' | 'lg';
  noteFormMethods?: any;
};

const ScenarioSide = (props: Props) => {
  const getSize = () => {
    switch (props?.size) {
      case 'sm':
        return 'md:tw-w-[310px] tw-w-full';
      case 'lg':
        return 'md:tw-w-[650px] tw-w-full';
      default:
        return 'md:tw-w-[580px] tw-w-full';
    }
  };
  const renderChildren = () => {
    return (
      <>
        <div className="tw-p-2">{props.children?.[0]}</div>
        <div className="tw-h-full tw-overflow-y-auto tw-overflow-x-hidden">{props.children?.[1]}</div>
        <div className="tw-p-2">{props.children?.[2]}</div>
        {props.children?.[3]}
      </>
    );
  };
  const formClasses = ` tw-absolute tw-right-0 tw-bg-gray-50 tw-flex tw-h-full tw-flex-col tw-justify-between ${getSize()} ${props.className}`;
  return props.onSubmit ? (
    <form onSubmit={props.onSubmit} className={formClasses}>
      {renderChildren()}
    </form>
  ) : (
    <div className={formClasses}>{renderChildren()}</div>
  );
};

export default ScenarioSide;
